import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

import fourPersonBoxImg from 'media/images/box-prices/four-person-box.jpg'
import twoPersonBoxImg from 'media/images/box-prices/two-person-box.jpg'

export const PaymentMethod = {
  Card: 'Card',
  PayPal: 'PayPal',
  ApplePay: 'ApplePay',
}

const checkAccountPageSlug = 'start'
const applyVoucherPageSlug = 'apply-voucher'
const enterPromoCodeManuallyPageSlug = 'enter-discount-code'
const postcodeSlug = 'postcode'

export const signupConfig = {
  /**
   * If experiment steps should be added:
   * 1. Create another entry in signupConfig with listing appropriate steps (similar to signupConfig.defaultSteps).
   * 2. Add entries of new steps into signupConfig.steps array.
   * 3. Refer to new steps variable in "getSignupSteps.ts" file.
   * 4. Map step to component in "AvailableStepComponents.ts" file.
   */
  defaultSteps: [SignupSteps.BOX_SIZE, SignupSteps.POSTCODE, SignupSteps.DELIVERY],
  explainTheWizardSteps: [
    SignupSteps.EXPLAIN_THE_WIZARD,
    SignupSteps.BOX_SIZE,
    SignupSteps.POSTCODE,
    SignupSteps.DELIVERY,
  ],
  personaliseMenuSteps: [
    SignupSteps.BOX_SIZE,
    SignupSteps.POSTCODE,
    SignupSteps.DELIVERY,
    SignupSteps.PERSONALISE_MENU,
  ],
  boxPriceBreakdownSteps: [
    SignupSteps.BOX_SIZE_PRICE_BREAKDOWN,
    SignupSteps.POSTCODE,
    SignupSteps.DELIVERY,
  ],
  deliveryAnxietyAndBoxSteps: [
    SignupSteps.BOX_SIZE_PRICE_BREAKDOWN,
    SignupSteps.POSTCODE,
    SignupSteps.DELIVERY_DATE,
  ],
  deliveryAnxietySteps: [SignupSteps.BOX_SIZE, SignupSteps.POSTCODE, SignupSteps.DELIVERY_DATE],
  steps: [
    { name: SignupSteps.EXPLAIN_THE_WIZARD, slug: 'explain-the-wizard' },
    { name: SignupSteps.BOX_SIZE, slug: 'box-size' },
    { name: SignupSteps.BOX_SIZE_PRICE_BREAKDOWN, slug: 'box-size' },
    { name: SignupSteps.POSTCODE, slug: 'postcode' },
    { name: SignupSteps.DELIVERY, slug: 'delivery-options' },
    { name: SignupSteps.DELIVERY_DATE, slug: 'delivery-options' },
    { name: SignupSteps.PERSONALISE_MENU, slug: 'personalise-menu' },
  ],
  payment_types: {
    card: 'card',
    paypal: 'paypal',
  },
  address_types: {
    billing: 'billing',
    shipping: 'shipping',
  },
  boxSizeStep: {
    title: 'Choose your box size',
    cta: 'Select',
    boxSize: {
      2: {
        description:
          'This smaller box is packed with enough pre-measured ingredients for each recipe to feed 2 people.',
        image: twoPersonBoxImg,
      },
      4: {
        description:
          'This larger box is packed with enough pre-measured ingredients for each recipe to feed 4 people.',
        image: fourPersonBoxImg,
      },
    },
    discountApplied: 'Discount applied',
    boxSizeTypes: [
      {
        heading: 'Regular box',
        recipeInfoTextStart: 'You can choose from ',
        recipeInfoStrongText: '2 to 5',
        recipeInfoTextEnd: ' recipes per box.',
        suitableFor: ['2 adults (or 1 + leftovers)', '1 adult and 1-2 children'],
        ctaText: 'Choose regular box',
        value: 2,
      },
      {
        heading: 'Large box',
        recipeInfoTextStart: 'You can choose from ',
        recipeInfoStrongText: '2 to 4',
        recipeInfoTextEnd: ' recipes per box.',
        suitableFor: ['4 adults (or 2-3 + leftovers)', '2 adults and 2-3 children'],
        ctaText: 'Choose large box',
        value: 4,
      },
    ],
  },
  boxSizePriceBreakdownStep: {
    boxSizeTypes: [
      {
        heading: 'Regular box',
        subHeading: '2 generous portions per chosen recipe',
        ctaText: 'Choose regular box',
        value: 2,
      },
      {
        heading: 'Large box',
        subHeading: '4 generous portions per chosen recipe',
        ctaText: 'Choose large box',
        value: 4,
      },
    ],
    accordionTitle: 'price breakdown',
    pricePlaceholder: '£--.--',
    wasPricePlaceholder: 'Was £--.--',
    boxInfoTextStart: 'From',
    boxInfoTextEnd: 'per box',
  },
  postCodeStep: {
    title: 'Where would you like your boxes delivered?',
    explainTheWizardTitle: 'Enter your postcode to see if we can deliver the box to your area!',
    explainTheWizardDescription: 'Don’t worry, we don’t store this information unless you sign up.',
    goustoOnDemandTitle: 'Where would you like your box delivered?',
    reminder: 'Delivered to your door, 7 days a week',
    doNotDeliverErrorMessage: 'Sorry, it looks like we don’t currently deliver to your area.',
    genericErrorMessage: 'Please enter a valid postcode',
  },
  deliveryOptionsStep: {
    title: 'When would you like your first box delivered?',
    explainTheWizardTitle: 'Choose your delivery date to see the menu for that day!',
    goustoOnDemandTitle: 'When do you want your box delivered?',
  },
  discountAppliedText: 'View this when you reach the checkout.',
  sellThePropositionPageSlug: 'about',
  checkAccountPageSlug,
  applyVoucherPageSlug,
  enterPromoCodeManuallyPageSlug,
  canLandOnStepWithoutRedirecting: [
    checkAccountPageSlug,
    applyVoucherPageSlug,
    enterPromoCodeManuallyPageSlug,
    /**
     * Required for redirected to postcode from box prices.
     */
    postcodeSlug,
  ],
}
